<template>
  <a
    class="article-edit"
    :href="`${$options.HOME_URL}/wp-admin/post.php?post=${article.id}&action=edit`"
    :aria-label="`Редактировать статью ${article.title}`"
    target="_blank"
  >
    <SvgAsset
      class="article-edit__edit-icon"
      :content="editPath"
    />
  </a>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { IFullArticle, TArticle } from '~/types/common';
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';
  import { HOME_URL } from '~/constants/config';
  import editPath from '@/assets/images/svg/edit.svg?raw';

  export default defineNuxtComponent({
    name: 'ArticleEdit',

    components: { SvgAsset },

    HOME_URL,

    props: {
      article: {
        type: Object as PropType<IFullArticle | TArticle>,
        required: true,
      },
    },

    computed: {
      editPath: () => editPath,
    },
  });
</script>

<style lang="scss" scoped>
  .article-edit {
    padding: $spacing-2;
    background: #ffffff;
    border: 1px solid #e7e7e7;
    box-shadow: 0 8px 14px rgba(0, 0, 0, 0.05);
    border-radius: 40px;
    display: block;

    @include hover {
      border-color: black;

      .article-edit__edit-icon {
        color: black;
      }
    }

    &__edit-icon {
      color: #969698;

      :deep(svg) {
        display: block;
        width: 24px;
        height: 24px;
      }
    }
  }
</style>
